import { Container, interaction } from 'pixi.js';
import { Button } from "./Button";

/**
 */
export class ButtonAnimator {
  /**
   */
  public target: Button;

  /**
   * @param target
   */
  public init(target: Button) {
    this.target = target;
  }

  /**
   * Called on animation start. Override this and do your async
   * animation and then call resolve.
   *
   * @param target - Target Container.
   * @param resolve - Resolve callback.
   */
  public play(target: Container, resolve: Function) {
    resolve();
  }

  public down(e: interaction.InteractionEvent) {}

  public up(e: interaction.InteractionEvent) {}

  public over(e: interaction.InteractionEvent) {}

  public out(e: interaction.InteractionEvent) {}
}
